'use client';

import React from 'react';
import { Button, Group, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { LegsTable } from './LegsTable';
import { isMultiLegTrip, type Trip } from '@/types/trip';

interface EditTripModalProps {
  opened: boolean;
  onClose: () => void;
  trip: Trip;
  onEdit: () => void;
}

export function EditTripModal({ onClose, trip, onEdit }: Omit<EditTripModalProps, 'opened'>) {
  const { t } = useTranslation();

  return (
    <Stack gap="md">
      <Text size="sm" c="dimmed">
        {t('detallesViaje')}
      </Text>

      {isMultiLegTrip(trip) ? (
        <LegsTable legs={trip.legs} readOnly />
      ) : (
        <Text>{t('trips.legacyTripNotSupported')}</Text>
      )}

      <Group justify="flex-end" mt="md">
        <Button variant="default" onClick={onClose}>
          {t('common.cancel')}
        </Button>
        <Button onClick={onEdit}>{t('common.edit')}</Button>
      </Group>
    </Stack>
  );
}
